<template>
  <div class="container">
    <div class="post">
      <div class="by"><leech-logo :color="iconHexColor"></leech-logo></div>
      <div class="block">
        <div class="creation">
          {{ createdDateTime }} - {{ createdByUserName }}
        </div>
        <div class="title">{{ postTitle }}</div>
        <div class="content">{{ postBody }}</div>
        <div class="info">
          <div class="bit link" @click="like">{{ likes }} igler</div>
          |
          <div class="bit link" @click="dislike">{{ dislikes }} pikke</div>
        </div>
      </div>
    </div>
    <comment
      v-for="(cmt, index) in comments"
      v-bind="cmt"
      :index="index"
      :key="index"
    ></comment>
    <form @submit.prevent="submit" class="comment">
      <input ref="cmt" type="text" v-model="cmtText" />
      <button ref="btn" @click="addComment">Gem</button>
    </form>
  </div>
</template>

<script>
import router from "../router";
import LeechLogo from "./LeechLogo.vue";
import Comment from "./Comment.vue";

export default {
  components: {
    LeechLogo,
    Comment,
  },
  data() {
    return {
      forumPostId: 0,
      postTitle: "",

      postBody: "",
      postImage: null,

      iconHexColor: "",
      createdDateTime: "",

      comments: [],
      likes: 0,
      dislikes: 0,

      createdByUserName: "",

      cmtText: "",
    };
  },
  mounted() {
    var vm = this;
    this.$store
      .dispatch("api/get", { url: "/1/post/" + this.$route.params.id })
      .then((payload) => {
        vm.forumPostId = payload.data.forumPostId;
        vm.postTitle = payload.data.postTitle;
        vm.postBody = payload.data.postBody;
        vm.postImage = payload.data.postImage;
        vm.iconHexColor = payload.data.iconHexColor;
        vm.createdDateTime = payload.data.createdDateTime;
        vm.comments = payload.data.comments;
        vm.likes = payload.data.likes;
        vm.dislikes = payload.data.dislikes;
      })
      .catch(() => router.push("/forum"));
  },
  methods: {
    like() {
      this.likes += 1;
      this.$store
        .dispatch("api/post", {
          url: "/1/post/" + this.$route.params.id + "/like",
        })
        .then(() => {})
        .catch(() => {});
    },
    dislike() {
      this.dislikes += 1;
      this.$store
        .dispatch("api/post", {
          url: "/1/post/" + this.$route.params.id + "/dislike",
        })
        .then(() => {})
        .catch(() => {});
    },
    addComment() {
      if (this.cmtText.length < 1) {
        return;
      }

      this.$refs["cmt"].disabled = true;
      this.$refs["btn"].disabled = true;

      var vm = this;
      this.$store
        .dispatch("api/post", {
          url: "/1/post/" + this.$route.params.id + "/comment",
          data: { comment: { commentText: vm.cmtText } },
        })
        .then(() => this.rerender())
        .catch(() => {
          vm.$refs["cmt"].value = "";
          vm.$refs["cmt"].disabled = false;
          vm.$refs["btn"].disabled = false;
        });
    },
    rerender() {
      this.$emit("refresh");
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 1 auto;
}

.post {
  max-width: calc(100% - 30px);
  width: 1000px;
  background-color: #ffffff;
  box-shadow: 0 0 10px #999999;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 30px;
  position: relative;

  transition: box-shadow 0.2s, width 0.2s;

  .by {
    position: absolute;
    top: 5px;
    left: -70px;
    height: 60px;
    width: 60px;
    padding: 5px;
    box-sizing: border-box;
    border-radius: 50%;
    background-color: #ffffff;
    box-shadow: 0 0 10px #999999;
  }

  .block {
    width: 100%;

    .creation {
      font-size: 13px;
      font-style: italic;
      color: #666666;
    }

    .title {
      padding: 20px 10px;
      font-size: 26px;
      font-weight: bold;
      margin-bottom: 20px;
    }

    .content {
      padding: 20px 10px;
      font-size: 16px;
      font-weight: bold;
      white-space: pre-wrap;
    }

    .info {
      font-size: 13px;
      font-style: italic;
      color: #333333;
      display: flex;

      .bit {
        font-size: inherit;
        font-style: inherit;
        margin: 0 10px;

        cursor: pointer;
      }
    }
  }
}

.comment {
  max-width: calc(100% - 30px);
  width: 1000px;
  background-color: #ffffff;
  box-shadow: 0 0 10px #999999;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 20px;
  border-radius: 6px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;

  input {
    font-size: 13px;
    padding: 10px 5px;
    width: calc(100% - 100px);
  }

  button {
    border: none;
    font-size: 18px;
    padding: 12px 25px;
    font-weight: 600;
    box-shadow: 0 0 5px #999999;
    color: #ffffff;
    cursor: pointer;
    background-color: #d05366;
    margin-left: 15px;
    transition: box-shadow 0.2s;

    &:hover {
      box-shadow: 0 0 10px #333333;
    }
  }
}

@media only screen and (max-width: 1150px) {
  .post {
    margin: 80px 0 20px;

    .by {
      top: -70px;
      left: 5px;
    }
  }
}
</style>
